import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const academicSlice = createSlice ({

    name :"academic",
    initialState:
    {
        departments:
        {
            data:[],
            loading:false,
            error: null
        },
        programs:
        {
            data:[],
            loading:false,
            error: null
        },
        loan:
        {
            data:[],
            loading:false,
            error: null
        }

    },
    reducers:
    {

        fetchDepartmentsStart(state) {
            state.departments.loading = true;
            state.departments.error = null;
          },
          fetchDepartmentsSuccess(state, action) {
           
            state.departments.loading = false;
            state.departments.data = action.payload;
          },
          fetchDepartmentsFailure(state, action) {
            state.departments.loading = false;
            state.departments.error = action.payload;
          },

        fetchProgramsStart(state) {
            state.programs.loading = true;
            state.programs.error = null;
          },
          fetchProgramsSuccess(state, action) {
          
            state.programs.loading = false;
            state.programs.data = action.payload;
          },
          fetchProgramsFailure(state, action) {
            state.programs.loading = false;
            state.programs.error = action.payload;
          },

          fetchLoanStart(state) {
            state.loan.loading = true;
            state.loan.error = null;
          },
          fetchLoanSuccess(state, action) {
            console.log("loan Success Payload:", action.payload);
            state.loan.loading = false;
            state.loan.data = action.payload;
          },
          fetchLoanFailure(state, action) {
            state.loan.loading = false;
            state.loan.error = action.payload;
          },

    }
});

export const {

    fetchDepartmentsStart,
    fetchDepartmentsSuccess,
    fetchDepartmentsFailure,
    fetchProgramsStart,
    fetchProgramsSuccess,
    fetchProgramsFailure,
    fetchLoanStart,
    fetchLoanSuccess,
    fetchLoanFailure
  
} = academicSlice.actions;

export const fetchDepartmentsData = () => async (dispatch) => {
    dispatch(fetchDepartmentsStart());
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/academicPage/getDepartment`
      );
    
      const data = response.data.data || [];
      dispatch(fetchDepartmentsSuccess(data));
    } catch (error) {
      console.error("API Error:", error);
      dispatch(fetchDepartmentsFailure(error.message || "Something went wrong"));
    }
    
  };

export const fetchProgramsData = () => async (dispatch) => {
    dispatch(fetchProgramsStart());
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/academicPage/getAllInternationalProgram`
      );
     
      const data = response.data.data || [];
      dispatch(fetchProgramsSuccess(data));
    } catch (error) {
      console.error("API Error:", error);
      dispatch(fetchProgramsFailure(error.message || "Something went wrong"));
    }
    
  };


  export const fetchLoanData = () => async (dispatch) => {
    dispatch(fetchLoanStart());
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/academicPage/getLoanScheme`
      );
      console.log("API Response:", response.data); // Debug log
      const data = response.data.data || [];
      dispatch(fetchLoanSuccess(data));
    } catch (error) {
      console.error("API Error:", error);
      dispatch(fetchLoanFailure(error.message || "Something went wrong"));
    }
    
  };

export default academicSlice.reducer;